export const LABELS_TEXT = {
  ASSIGN_TO: 'Assigned to company',
  ASSIGN_BY: 'Assigned by',
  COMPANY_USER: 'Company user',
  MODAL_TITLE: 'New company pricebook',
  BUSINESS_UNIT: 'Business Unit'
};
